import type { AutosaveStatus } from '../lib/autosave.js';

const labels: Record<AutosaveStatus, string> = {
  Idle: 'Changes waiting to save',
  Saving: 'Saving…',
  Saved: 'Saved just now',
  Error: 'Could not save',
  Conflict: 'Conflict — review changes',
};

export function SaveState({ status }: { status: AutosaveStatus }) {
  return (
    <span
      className={`save-state save-state--${status.toLowerCase()}`}
      role="status"
      aria-live="polite"
    >
      <span className="save-state__dot" aria-hidden="true" />
      {labels[status]}
    </span>
  );
}
